import type { BankDetailsFindInterface } from '@zaoblako/shared/modules/client/dtos/bank.details/bank-details-find.dto';
import type { BankDetailsEntity } from '@infrastructure/database/entities/client/bank-details.entity';
import type { DeepPartial } from 'typeorm';

/** Provides additional utils for bank details entities. Singleton object. */
export class BankDetailsHelperClass {
  private static instance: BankDetailsHelperClass = null;

  public static getInstance(): BankDetailsHelperClass {
    if (!BankDetailsHelperClass.instance) {
      BankDetailsHelperClass.instance = new BankDetailsHelperClass();
    }
    return BankDetailsHelperClass.instance;
  }

  /**
   * Returns localized human readable string representation of bank details.
   * Need for history logs.
   *
   * @param value Bank details to stringify
   *
   * @returns String representation of bank details
   */
  public format = (value: DeepPartial<BankDetailsEntity> | DeepPartial<BankDetailsFindInterface>): string => {
    if (!value) {
      return '';
    }

    let result = value.checkingAccount
      ? `р/с ${value.checkingAccount}`
      : `№${value.id}`;
    if (value.bank?.name) {
      result = `${result}, банк "${value.bank.name}"`;
      if (value.bank.bik) {
        result = `${result} (БИК ${value.bank.bik})`;
      }
    }

    return result;
  }
}
